import { gql } from "@apollo/client";

const schema = {
  request: {
    name: "activateDoctorRequest",
    serviceName: "auth",
    query: gql`
      mutation activateDoctorRequest {
        activateDoctorRequest {
          messages
        }
      }
    `,
  },
};

export default schema;
